import { NavLink } from 'react-router-dom';
import { Home, BookOpen, MessageSquare, BarChart3, Building2 } from 'lucide-react';
import { useAuth } from '@features/auth';
import { useMobileMenu } from '@/shared/contexts/MobileMenuContext';
import { cn } from '@/shared/components/ui/utils';

interface NavItem {
  path: string;
  icon: React.ComponentType<{ className?: string }>;
  label: string;
}

const navItemsByRole: Record<string, NavItem[]> = {
  student: [
    { path: '/dashboard', icon: Home, label: 'Inicio' },
    { path: '/lms', icon: BookOpen, label: 'Cursos' },
    { path: '/forum', icon: MessageSquare, label: 'Foro' },
  ],
  teacher: [
    { path: '/dashboard', icon: Home, label: 'Inicio' },
    { path: '/lms', icon: BookOpen, label: 'LMS' },
    { path: '/forum', icon: MessageSquare, label: 'Foro' },
  ],
  director: [
    { path: '/dashboard', icon: Home, label: 'Inicio' },
    { path: '/estructura', icon: Building2, label: 'Estructura' },
    { path: '/estadisticas', icon: BarChart3, label: 'Stats' },
    { path: '/forum', icon: MessageSquare, label: 'Foro' },
  ],
};

export function MobileBottomNav() {
  const { user } = useAuth();
  const { isOpen: isSidebarOpen } = useMobileMenu();
  const role = user?.role || 'student';
  const items = navItemsByRole[role] || navItemsByRole.student;

  // Hide bottom nav when mobile sidebar is open so it doesn't overlap the profile section
  if (isSidebarOpen) return null;

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 z-50"
      aria-label="Navegacion movil"
      style={{
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <div className="flex justify-around items-center py-2.5 px-4">
        {items.map(({ path, icon: Icon, label }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center py-2 px-4 rounded-xl min-w-[72px]',
                'transition-all duration-200',
                isActive
                  ? 'text-[#6D5DFE] dark:text-[#A599FF] bg-[#6D5DFE]/10 dark:bg-[#A599FF]/15'
                  : 'text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300'
              )
            }
          >
            {({ isActive }) => (
              <>
                <Icon className={cn('w-6 h-6', isActive && 'stroke-[2.5px]')} />
                <span className={cn('text-xs mt-1', isActive ? 'font-semibold' : 'font-medium')}>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
